// Selector con buscador sobre la biblioteca de ejercicios del coach. Lo usan
// el modal de subida y el de cambio de ejercicio de un vídeo.
import { useMemo, useState } from "react";
import { MagnifyingGlassIcon, CheckIcon } from "@heroicons/react/24/outline";
import { useFetchExercisesQuery } from "../../store";
import { useCoach } from "../../hooks/useCoach";

export default function ExercisePicker({ value, onChange, disabled, label = "Exercise" }) {
  const { coach } = useCoach();
  const { data: exercises, isLoading } = useFetchExercisesQuery(coach?.id, { skip: !coach?.id });
  const [query, setQuery] = useState("");
  const inputId = "exercise-picker-search";

  const matches = useMemo(() => {
    const list = exercises || [];
    const q = query.trim().toLowerCase();
    const filtered = q ? list.filter((e) => e.name?.toLowerCase().includes(q)) : list;
    return filtered.slice(0, 50);
  }, [exercises, query]);

  return (
    <div>
      <label htmlFor={inputId} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      {value ? (
        <div className="mt-1 flex items-center justify-between rounded-md bg-indigo-50 px-3 py-2 ring-1 ring-inset ring-indigo-200">
          <span className="flex items-center gap-2 text-sm font-medium text-indigo-900">
            <CheckIcon className="h-4 w-4" />
            {value.name}
          </span>
          <button
            type="button"
            className="text-sm font-semibold text-indigo-700 hover:text-indigo-900 disabled:opacity-40"
            onClick={() => onChange(null)}
            disabled={disabled}
          >
            Change
          </button>
        </div>
      ) : (
        <>
          <div className="relative mt-1">
            <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
            <input
              id={inputId}
              type="text"
              autoComplete="off"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search the exercise library…"
              disabled={disabled}
              className="block w-full rounded-md border border-gray-300 py-2 pl-10 pr-3 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 disabled:opacity-40 sm:text-sm"
            />
          </div>
          <ul className="mt-1 max-h-48 overflow-y-auto rounded-md border border-gray-200 text-sm">
            {isLoading ? (
              <li className="px-3 py-2 text-gray-500">Loading exercises…</li>
            ) : matches.length === 0 ? (
              <li className="px-3 py-2 text-gray-500">No exercises match "{query}".</li>
            ) : (
              matches.map((e) => (
                <li key={e.id}>
                  <button
                    type="button"
                    onClick={() => onChange(e)}
                    disabled={disabled}
                    className="block w-full px-3 py-2 text-left text-gray-900 hover:bg-indigo-50 disabled:opacity-40"
                  >
                    {e.name}
                  </button>
                </li>
              ))
            )}
          </ul>
        </>
      )}
    </div>
  );
}
